<template>
    <div class="overlay" v-if="$store.getters.hasPopupWithSelectbox">
        <div class="overlay_inner success">

            <p class="field">
                <select-box
                    id="option"
                    :options="options"
                    v-model="selectedOptionId"
                    ref="optionref">
                  {{ $store.getters.getPopupWithSelectboxMessage }}
                </select-box>
            </p>

            <p class="buttons">
                <a class="btn" :title="$store.getters.getPopupWithSelectboxSubmitButtonText | translate"
                   @click.stop.prevent="submitPopup">{{ $store.getters.getPopupWithSelectboxSubmitButtonText }}</a>
            </p>

            <a class="btn btn_action btn_close" :title="'Zavřít' | translate" @click.stop.prevent="closePopup"
               v-translate>Zavřít</a>
        </div>
    </div>
</template>

<script>

import formFields from "@/components/mixins/form-fields"
import detailActions from "@/components/mixins/detail-actions"
import {HIDE_POPUP_WITH_SELECTBOX} from "../../store/mutation-types";

export default {
    name: "PopupWithSelectbox",
    components: {},
    mixins: [formFields, detailActions],
    props: {
        messageParams: Object,
    },
    data: function () {
        return {
            selectedOptionId: null
        }
    },
    methods: {
        closePopup() {
            this.$store.commit(HIDE_POPUP_WITH_SELECTBOX);
        },
        submitPopup() {
            this.$emit('submitAction', this.$store.getters.getPopupWithSelectboxAction, this.selectedOptionId, this.$store.getters.getPopupWithSelectboxData);
            this.closePopup();
        }
    },
    computed: {
        options() {
            if (this.$store.getters.getPopupWithSelectboxOptions) {
                this.selectedOptionId = this.$store.getters.getPopupWithSelectboxOptions[0].id;

                return this._.map(this.$store.getters.getPopupWithSelectboxOptions, function (item) {
                    return {id: item['id'], text: item['name']}
                });
            } else {
                return []
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/PopupWithSelectbox.vue